import React, { useState } from "react";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";
import { Button, Text, useTheme } from "react-native-paper";
import { OutlinedInput } from "../../components/fields/OutlinedInput";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../types/navigationParams";
import { useTranslation } from "react-i18next";
import { Company, updateTimestampAction } from "../../redux/slices/authSlice";
import { addInvitation } from "../../services/employeeServices";
import * as z from "zod";
import { DEFAULT_ROLE } from "../../constants/constants";

const schema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
});

type FormProps = NativeStackScreenProps<RootStackParamList, "NewEmployeeForm">;

export default function NewEmployeeForm({ navigation }: FormProps) {
  const company = useAppSelector((state) => state.auth.user.company);
  const config = useAppSelector((state) => state.auth.config);
  const [email, setEmail] = useState("");
  // const [role, setRole] = useState("");
  const [errors, setErrors] = useState<{ email?: string; role?: string }>({});
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const validateForm = () => {
    try {
      schema.parse({ email, role: DEFAULT_ROLE });
      setErrors({});
      return true;
    } catch (err) {
      if (err instanceof z.ZodError) {
        const newErrors: Record<string, string> = {};
        err.issues.forEach((error) => {
          if (error.path.length) {
            newErrors[error.path[0] as string] = error.message;
          }
        });
        setErrors(newErrors);
      }
      return false;
    }
  };

  const onSubmit = async () => {
    if (!validateForm()) return;

    await addInvitation(email, company as Company, DEFAULT_ROLE);

    dispatch(updateTimestampAction());

    alert(t("Invited successfully!"));
    navigation.goBack();
  };

  return (
    <KeyboardAwareScrollView
      contentContainerStyle={{ padding: 20, gap: 10 }}
      bottomOffset={20}
      keyboardShouldPersistTaps="handled"
    >
      <OutlinedInput
        mode="outlined"
        placeholder="employee@example.com"
        value={email}
        label={t("Email")}
        onChangeText={setEmail}
        error={!!errors.email}
      />
      {errors.email && (
        <Text style={{ color: theme.colors.error }}>{t(errors.email)}</Text>
      )}

      {/*<View>*/}
      {/*  <OutlinedInput*/}
      {/*    value={t(role)}*/}
      {/*    label={t("Select role")}*/}
      {/*    editable={false}*/}
      {/*    right={<TextInput.Icon icon="chevron-down" />}*/}
      {/*    error={!!errors.role}*/}
      {/*  />*/}
      {/*<Pressable*/}
      {/*  testID={"select-role"}*/}
      {/*  style={{*/}
      {/*    position: "absolute",*/}
      {/*    width: "100%",*/}
      {/*    height: "100%",*/}
      {/*  }}*/}
      {/*  onPress={() =>*/}
      {/*    navigation.navigate("PickerScreen", {*/}
      {/*      options: config.roles.map((item) => ({*/}
      {/*        label: item,*/}
      {/*        value: item,*/}
      {/*      })),*/}
      {/*      onValueChange: (item: { label: string; value: string }) =>*/}
      {/*        setRole(item.value),*/}
      {/*      disableSearch: true,*/}
      {/*    })*/}
      {/*  }*/}
      {/*/>*/}
      {/*</View>*/}
      {/*{errors.role && (*/}
      {/*  <Text style={{ color: theme.colors.error }}>{t(errors.role)}</Text>*/}
      {/*)}*/}

      <Button testID={"invite"} onPress={onSubmit}>
        {t("Invite")}
      </Button>
    </KeyboardAwareScrollView>
  );
}
